// List of service phone numbers
export const phoneNumbers = {
  general: [
    '+919983916148',
    '+919145842508',
    '+918559939924'
  ],
  'ac-repair': [
    '+919587520140',
    '+917792927884',
    '+918696953514'
  ],
  'refrigerator-repair': [
    '+919145842509',
    '+917792931295',
    '+918559943568'
  ],
  'washing-machine-repair': [
    '+919461204899',
    '+918559930443',
    '+918559930078'
  ],
  'tv-repair': [
    '+918559929954',
    '+918058389271',
    '+918559930119'
  ],
  'water-purifier-repair': [
    '+919983916148',
    '+919145842508',
    '+918559939924'
  ],
  'microwave-repair': [
    '+919587520140',
    '+917792927884',
    '+918696953514'
  ]
};

// Get a random phone number from a specific service category
export function getServicePhoneNumber(service?: string): string {
  // If no service is provided or the service doesn't exist, return a general number
  const numbers = service && phoneNumbers[service] ? phoneNumbers[service] : phoneNumbers.general;
  return numbers[Math.floor(Math.random() * numbers.length)];
}